module.exports = __webpack_public_path__ + "assets/52e1f69600047904c5046dfed798e056.png";